module.exports = __webpack_public_path__ + "static/art-dyb-1.08eeedd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/art-dyb-1.png
// module id = 445
// module chunks = 35783957827783